import axios from "axios";

export default {
  user: {
    begin: async user => { 
      let url = `${process.env.REACT_APP_ESIGN_API_URL}/u/esign/begin`;       
      return await axios.create().post(url, { user }).then(res => res.data);
    },
    review: async (apikey, token, data) => { 
      let url = `${process.env.REACT_APP_ESIGN_API_URL}/u/esign/review`; 
      return await getAuthedAxios(apikey, token).post(url, data).then(res => res.data)
    },
    summary: async (apikey, token, data) => { 
      let url = `${process.env.REACT_APP_ESIGN_API_URL}/u/esign/summary`;
      return await getAuthedAxios(apikey, token).post(url, data).then(res => res.data);     
    },
  },
  center : {
    get: async (cId, what) => { 
      let url = `${process.env.REACT_APP_ESIGN_API_URL}/c/center/${cId}/${what}`;       
      return await axios.create().get(url).then(res => res.data);
    },
  }  
};

function getAuthedAxios(apikey, token) {
  const axiosInstance = axios.create();
  axiosInstance.defaults.headers.post['x-api-key'] = apikey;
  axiosInstance.defaults.headers.post['Authorization'] = `Bearer ${token}`; 
  return axiosInstance;
}